export const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform)
